export enum CaType {
  ROOT = 'ROOT',
  SUB = 'SUB',
  SIGNED_BY_EXTERNAL = 'SIGNED_BY_EXTERNAL',
}
